import type { FetchBaseQueryError } from '@reduxjs/toolkit/query/react';

import type { ApiErrorBody } from '@/api/orgTokenTypes';

function hasErrorMessage(data: unknown): data is ApiErrorBody {
    return (
        typeof data === 'object' &&
        data !== null &&
        typeof (data as ApiErrorBody).error === 'string'
    );
}

/** Every hub error response is `{ error: string }` — see orgToken.routes.js. */
export function apiErrorMessage(error: unknown, fallback = 'Something went wrong'): string {
    if (!error || typeof error !== 'object') return fallback;
    const fetchError = error as FetchBaseQueryError;
    if (hasErrorMessage(fetchError.data)) return fetchError.data.error;
    if ('status' in fetchError) return `Request failed (${String(fetchError.status)})`;
    return fallback;
}
